"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _systemSetting = require("@/api/systemSetting.js");
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi.js"));
var _menuBarConfig = require("./menuBarConfig");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var MAX_IMAGE_SIZE = 10 * 1024;
var _default = exports.default = {
  name: 'MenuBarManage',
  components: {
    draggable: _vuedraggable.default
  },
  data: function data() {
    return {
      MENU_LINK_OPTIONS: _menuBarConfig.MENU_LINK_OPTIONS,
      MENU_BAR_MAX_COUNT: _menuBarConfig.MENU_BAR_MAX_COUNT,
      MENU_BAR_IMAGE_TIP: _menuBarConfig.MENU_BAR_IMAGE_TIP,
      drawerVisible: false,
      loading: false,
      saving: false,
      appInfo: {},
      menuList: (0, _menuBarConfig.createDefaultMenuList)(),
      userType: null
    };
  },
  methods: {
    open: function open(row) {
      this.appInfo = row || {};
      this.drawerVisible = true;
      this.loadMenuBar();
    },
    handleClose: function handleClose() {
      this.drawerVisible = false;
      this.menuList = (0, _menuBarConfig.createDefaultMenuList)();
      this.appInfo = {};
    },
    loadMenuBar: function () {
      var _loadMenuBar = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (this.appInfo.id) {
                _context.n = 1;
                break;
              }
              this.menuList = (0, _menuBarConfig.createDefaultMenuList)();
              return _context.a(2);
            case 1:
              this.loading = true;
              _context.p = 2;
              _context.n = 3;
              return companyappApi.getMenuBarApi(this.appInfo.id);
            case 3:
              res = _context.v;
              list = Array.isArray(res) ? res : (res === null || res === void 0 ? void 0 : res.list) || (res === null || res === void 0 ? void 0 : res.menuList) || (res === null || res === void 0 ? void 0 : res.data) || [];
              this.menuList = (0, _menuBarConfig.normalizeMenuList)(list);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.menuList = (0, _menuBarConfig.createDefaultMenuList)();
            case 5:
              _context.p = 5;
              this.loading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadMenuBar() {
        return _loadMenuBar.apply(this, arguments);
      }
      return loadMenuBar;
    }(),
    getEnabledCount: function getEnabledCount() {
      return this.menuList.filter(function (item) {
        return item.status === 1;
      }).length;
    },
    handleStatusChange: function handleStatusChange(val, index) {
      if (val === 1 && this.getEnabledCount() > _menuBarConfig.MENU_BAR_MAX_ENABLED) {
        this.$message.warning(_menuBarConfig.MENU_BAR_MAX_ENABLED_ERROR);
        this.$set(this.menuList[index], 'status', 0);
        return;
      }
      if (val === 0 && this.getEnabledCount() < _menuBarConfig.MENU_BAR_MIN_ENABLED) {
        this.$message.warning(_menuBarConfig.MENU_BAR_MIN_ENABLED_ERROR);
        this.$set(this.menuList[index], 'status', 1);
      }
    },
    onLinkTypeChange: function onLinkTypeChange(item) {
      item.linkUrl = (0, _menuBarConfig.getLinkUrlByType)(item.linkType);
      if (item.linkType !== 'share') {
        item.linkId = '';
        item.benefitPackageKey = '';
        item.offlineJumpId = '';
      }
    },
    onDragEnd: function onDragEnd() {
      this.menuList = this.menuList.map(function (item, index) {
        return _objectSpread(_objectSpread({}, item), {}, {
          sort: index
        });
      });
    },
    addModule: function addModule() {
      if (this.menuList.length >= _menuBarConfig.MENU_BAR_MAX_COUNT) {
        this.$message.warning("\u6700\u591A\u6DFB\u52A0".concat(_menuBarConfig.MENU_BAR_MAX_COUNT, "\u4E2A\u5BFC\u822A\u6A21\u5757"));
        return;
      }
      var status = this.getEnabledCount() >= _menuBarConfig.MENU_BAR_MAX_ENABLED ? 0 : 1;
      this.menuList.push((0, _menuBarConfig.createDefaultMenuItem)({
        title: '',
        linkType: 'home',
        linkUrl: (0, _menuBarConfig.getLinkUrlByType)('home'),
        status: status
      }));
    },
    canRemoveModule: function canRemoveModule(index) {
      return this.menuList.length > _menuBarConfig.MENU_BAR_MIN_COUNT;
    },
    removeModule: function removeModule(index) {
      if (!this.canRemoveModule(index)) {
        this.$message.warning("\u81F3\u5C11\u4FDD\u7559".concat(_menuBarConfig.MENU_BAR_MIN_COUNT, "\u4E2A\u5BFC\u822A\u6A21\u5757"));
        return;
      }
      this.menuList.splice(index, 1);
      this.onDragEnd();
    },
    validateImageFile: function validateImageFile(file) {
      var isImage = file.type && file.type.indexOf('image/') === 0;
      if (!isImage) {
        this.$message.error('只能上传图片文件！');
        return false;
      }
      if (file.size > MAX_IMAGE_SIZE) {
        this.$message.error(_menuBarConfig.MENU_BAR_IMAGE_SIZE_ERROR);
        return false;
      }
      return true;
    },
    validateImageData: function validateImageData(imageData) {
      var sizeBytes = this.parseAttachmentSizeBytes(imageData);
      if (sizeBytes != null && sizeBytes > MAX_IMAGE_SIZE) {
        this.$message.error(_menuBarConfig.MENU_BAR_IMAGE_SIZE_ERROR);
        return false;
      }
      return true;
    },
    parseAttachmentSizeBytes: function parseAttachmentSizeBytes(item) {
      if (!item) return null;
      var raw = item.attSize || item.att_size || item.fileSize || item.size;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'number') {
        return raw > 1024 * 500 ? raw : raw * 1024;
      }
      var str = String(raw).trim();
      var kbMatch = str.match(/^([\d.]+)\s*KB$/i);
      if (kbMatch) return parseFloat(kbMatch[1]) * 1024;
      var mbMatch = str.match(/^([\d.]+)\s*MB$/i);
      if (mbMatch) return parseFloat(mbMatch[1]) * 1024 * 1024;
      var num = parseFloat(str);
      if (!isNaN(num)) return num;
      return null;
    },
    uploadIcon: function uploadIcon(index, field) {
      var _this = this;
      try {
        var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
        this.userType = JavaInfo.type;
      } catch (e) {
        this.userType = null;
      }
      if (this.userType === 1) {
        this.$modalUpload(function (img) {
          if (!_this.validateImageData(img[0])) return;
          _this.$set(_this.menuList[index], field, img[0].sattDir);
        }, '1', 'system', false, {
          maxSizeKB: 10,
          maxSizeErrorMsg: _menuBarConfig.MENU_BAR_IMAGE_SIZE_ERROR
        });
        return;
      }
      var input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
          var file;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                file = e.target.files[0];
                if (!(!file || !_this.validateImageFile(file))) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _context2.n = 2;
                return _this.handleLocalUpload(file, index, field);
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }();
      input.click();
    },
    handleLocalUpload: function () {
      var _handleLocalUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(file, index, field) {
        var formData, loading, res, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              formData = new FormData();
              formData.append('multipart', file);
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context3.p = 1;
              _context3.n = 2;
              return (0, _systemSetting.fileImageApi)(formData, {
                model: 'product',
                pid: 1
              });
            case 2:
              res = _context3.v;
              loading.close();
              if (res && res.url) {
                this.$set(this.menuList[index], field, res.url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败，请重试');
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t2 = _context3.v;
              loading.close();
              this.$message.error('上传失败：' + (_t2.message || '请重试'));
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3]]);
      }));
      function handleLocalUpload(_x2, _x3, _x4) {
        return _handleLocalUpload.apply(this, arguments);
      }
      return handleLocalUpload;
    }(),
    validateBeforeSave: function validateBeforeSave() {
      if (this.menuList.length < _menuBarConfig.MENU_BAR_MIN_COUNT) {
        this.$message.warning("\u81F3\u5C11\u4FDD\u7559".concat(_menuBarConfig.MENU_BAR_MIN_COUNT, "\u4E2A\u5BFC\u822A\u6A21\u5757"));
        return false;
      }
      if (this.menuList.length > _menuBarConfig.MENU_BAR_MAX_COUNT) {
        this.$message.warning("\u6700\u591A".concat(_menuBarConfig.MENU_BAR_MAX_COUNT, "\u4E2A\u5BFC\u822A\u6A21\u5757"));
        return false;
      }
      if (this.getEnabledCount() < _menuBarConfig.MENU_BAR_MIN_ENABLED) {
        this.$message.warning(_menuBarConfig.MENU_BAR_MIN_ENABLED_ERROR);
        return false;
      }
      if (this.getEnabledCount() > _menuBarConfig.MENU_BAR_MAX_ENABLED) {
        this.$message.warning(_menuBarConfig.MENU_BAR_MAX_ENABLED_ERROR);
        return false;
      }
      for (var i = 0; i < this.menuList.length; i++) {
        var item = this.menuList[i];
        if (item.status !== 1) continue;
        if (!item.title || !item.title.trim()) {
          this.$message.warning("\u7B2C".concat(i + 1, "\u4E2A\u5BFC\u822A\u8BF7\u586B\u5199\u6807\u9898"));
          return false;
        }
        if (!item.selectedIcon || !item.unselectedIcon) {
          this.$message.warning("\u7B2C".concat(i + 1, "\u4E2A\u5BFC\u822A\u8BF7\u4E0A\u4F20\u9009\u4E2D\u4E0E\u672A\u9009\u4E2D\u56FE\u6807"));
          return false;
        }
        if (!item.linkType) {
          this.$message.warning("\u7B2C".concat(i + 1, "\u4E2A\u5BFC\u822A\u8BF7\u9009\u62E9\u94FE\u63A5"));
          return false;
        }
        if (item.linkType === 'share') {
          if (!item.linkId || !String(item.linkId).trim()) {
            this.$message.warning("\u7B2C".concat(i + 1, "\u4E2A\u5BFC\u822A\uFF08\u88C5\u4FEE\u9875\uFF09\u8BF7\u586B\u5199\u88C5\u4FEE\u9875id"));
            return false;
          }
        }
      }
      return true;
    },
    handleSave: function () {
      var _handleSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var list, _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.validateBeforeSave()) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              list = this.menuList.map(function (item, index) {
                return (0, _menuBarConfig.uiMenuItemToApi)(_objectSpread(_objectSpread({}, item), {}, {
                  sort: index,
                  title: (item.title || '').trim(),
                  linkUrl: (0, _menuBarConfig.getLinkUrlByType)(item.linkType) || item.linkUrl || '',
                  linkId: item.linkType === 'share' ? String(item.linkId || '').trim() : '',
                  benefitPackageKey: item.linkType === 'share' ? String(item.benefitPackageKey || '').trim() : '',
                  offlineJumpId: item.linkType === 'share' ? String(item.offlineJumpId || '').trim() : ''
                }));
              });
              this.saving = true;
              _context4.p = 2;
              _context4.n = 3;
              return companyappApi.saveMenuBarApi({
                companyAppId: this.appInfo.id,
                list: list
              });
            case 3:
              this.$message.success('保存成功');
              this.$emit('refresh');
              this.handleClose();
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t3 = _context4.v;
            case 5:
              _context4.p = 5;
              this.saving = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2, 4, 5, 6]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }()
  }
};